var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasAnyFilters)?_c('div',{staticClass:"selected-filters-section"},[_c('div',{staticClass:"selected-filters-container"},_vm._l((_vm.allFilters),function(filter){return _c('filter-pill',{key:`${filter.type}-${filter.value}`,attrs:{"value":filter.value,"label":filter.label,"type":filter.type},on:{"remove":_vm.handleRemove}})}),1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }